module.exports = __webpack_public_path__ + "../resources/img/ic_re_refresh_default.fccad175.svg";